import Marquee from "react-fast-marquee";
import { useLang } from "../context/LanguageContext";
import { BrandShowcase } from "./BrandShowcase";
import { RadioTechCompare } from "./RadioTechCompare";
import { IntelbrasComparator } from "./IntelbrasComparator";
import { CctvCompare } from "./CctvCompare";
import { CctvGallery } from "./CctvGallery";
import { VsatBandCompare } from "./VsatBandCompare";
import { VsatGallery } from "./VsatGallery";
import { PartnersQuickNav } from "./PartnersQuickNav";

const BRANDS = [
  "MOTOROLA",
  "HYTERA",
  "INTELBRAS",
  "CISCO",
  "ALCATEL",
  "DSTV",
  "VSAT",
  "WIRELESS",
];

export const Partners = () => {
  const { t } = useLang();

  return (
    <>
      <section
        id="partners"
        data-testid="partners-section"
        className="relative scroll-mt-[160px] md:scroll-mt-[210px] lg:scroll-mt-[240px] border-y border-slate-200 py-20 lg:py-24"
      >
        {/* Background photo: telecom equipment flat-lay */}
        <div className="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
          <img
            src="/sections/partners-bg.png"
            alt=""
            aria-hidden
            loading="lazy"
            className="h-full w-full object-cover object-center"
            style={{ filter: "saturate(1.15) contrast(1.05)" }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#d6e6f2]/15 via-[#c8dceb]/25 to-[#a8c8e2]/40" />
        </div>
        <div className="relative mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
          <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
            <div>
              <div className="font-mono text-[11px] uppercase tracking-[0.28em] text-blue-600">
                {t.partners.overline}
              </div>
              <h2
                data-testid="partners-title"
                className="font-heading mt-4 max-w-2xl text-2xl font-bold tracking-tight text-slate-900 md:text-3xl lg:text-4xl"
              >
                {t.partners.title}
              </h2>
            </div>
          </div>
        </div>

        <div className="mt-12" data-testid="partners-marquee">
          <Marquee
            gradient
            gradientColor="#d6e6f2"
            gradientWidth={120}
            speed={40}
            pauseOnHover
          >
            {BRANDS.concat(BRANDS).map((b, i) => (
              <span
                key={`${b}-${i}`}
                className="font-heading mx-10 select-none text-4xl font-black uppercase tracking-widest text-blue-700/50 transition-colors duration-300 hover:text-blue-700 md:text-6xl lg:text-7xl"
              >
                {b}
                <span className="mx-8 text-blue-500/60">·</span>
              </span>
            ))}
          </Marquee>
        </div>
      </section>

      {/* RÁDIOS — decision helper followed by both radio brands */}
      <RadioTechCompare />
      <BrandShowcase brandId="motorola" />
      <BrandShowcase brandId="hytera" />

      {/* CENTRAIS TELEFÓNICAS — decision helper followed by both PBX brands */}
      <IntelbrasComparator />
      <BrandShowcase brandId="intelbras" />
      <BrandShowcase brandId="alcatel" />

      {/* NETWORKING — Cisco bridges PBX/IP to CCTV */}
      <BrandShowcase brandId="cisco" />

      {/* CCTV — decision helper followed by the equipment gallery */}
      <CctvCompare />
      <CctvGallery />

      {/* DSTV */}
      <BrandShowcase brandId="dstv" />

      {/* VSAT — decision helper followed by equipment gallery + brand showcase */}
      <VsatBandCompare />
      <VsatGallery />
      <BrandShowcase brandId="vsat" />

      <PartnersQuickNav />
    </>
  );
};
